var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmptySold = function SvgEmptySold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16003_1067)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6621 33V56.0078H34.0007V22.6692H23",
    stroke: "#757575",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99207 19L1.99219 10.0002H23.3308L34 22.6694H22",
    stroke: "#757575",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3386 50.5V22.6692H34V56.0078H39",
    stroke: "#757575",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0078 10.0002H44.6692L34 22.6694H55.3386L66.0078 10.0002Z",
    stroke: "#757575",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.96214 33H24.3743C26.1765 33 27.6511 31.5255 27.6511 29.7233C27.6511 27.921 26.1765 26.4465 24.3743 26.4465C24.2007 24.119 22.2574 22.2846 19.8855 22.2846C19.4701 22.2846 19.0679 22.3411 18.686 22.4466C17.4675 20.4176 15.2456 19.06 12.7066 19.06C8.8571 19.06 5.73661 22.1805 5.73661 26.03H4.985C3.06818 26.03 1.5 27.5982 1.5 29.515C1.5 31.4092 3.06104 33 4.96214 33Z",
    stroke: "#757575",
    strokeWidth: 2.5,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2072 64.9399H62.797C64.9871 64.9399 66.779 63.1481 66.779 60.958C66.779 58.768 64.9871 56.9761 62.797 56.9761C62.5861 54.1477 60.2245 51.9185 57.3422 51.9185C56.8374 51.9185 56.3486 51.9872 55.8846 52.1153C54.4038 49.6497 51.7037 47.9999 48.6184 47.9999C43.9404 47.9999 40.1484 51.792 40.1484 56.4699H39.235C36.9057 56.4699 35 58.3756 35 60.7049C35 63.0068 36.897 64.9399 39.2072 64.9399Z",
    stroke: "#757575",
    strokeWidth: 2.5,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16003_1067"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 68,
    fill: "white"
  })))));
};
export default SvgEmptySold;